import React, { FC, ReactNode } from 'react';
import { IconButton } from 'snacks-design-system';

export enum PIEIconButtonSizes {
  XSMALL = 'xsmall',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum PIEIconButtonModes {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  OUTLINE = 'outline',
  GHOST = 'ghost',
  GHOST_TERTIARY = 'ghost-tertiary',
  INVERSE = 'inverse',
  GHOST_INVERSE = 'ghost-inverse',
}

export interface IPIEIconButtonAria {
  label?: string;
  labelledby?: string;
  expanded?: boolean;
  controls?: string;
}

interface IPIEIconButton {
  className?: string;
  icon: ReactNode;
  size?: PIEIconButtonSizes;
  mode?: PIEIconButtonModes;
  disabled?: boolean;
  isLoading?: boolean;
  modDecoration?: boolean;
  aria?: IPIEIconButtonAria;
  keyCodes?: Array<number>;
  onClick?: () => void;
  onKeyUp?: () => void;
  qaSelector?: string;
  id?:string;
}

export const PIEIconButton: FC<IPIEIconButton> = (props) => {
  return <IconButton  {...props} />;
};
